const resources = {
    canadaCheckoutText: 'Canada checkout',
    unitedStatesCheckoutText: 'United States checkout'
};

export default function getResource(label) {
    return resources[label];
}
